<template>
    <div id="journalView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> # {{journal_number}}</div>
                    <div class="btn-groups text-right">
                        <button v-if="canUpdateJournal && is_editable == 1" type="submit" class="btn btn-primary" v-on:click.prevent="updateJournal">
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                        <button v-if="canDeleteJournal && is_editable == 1" type="submit" class="btn btn-danger" v-on:click.prevent="deleteJournal">Delete</button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackJournalList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="workorder-detail work-order-view-top" class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="list-view">
                                <div class="form-row no-divider">
                                    <div class="col-md-6">
                                        <!-- <div class="row form-group">
                                            <label class="col">Module :</label>
                                            <span class="col">{{module_text}}</span>
                                        </div> -->
                                        <div class="row form-group">
                                            <label class="col">Post Date :</label>
                                            <span class="col">{{post_date}}</span>
                                        </div>
                                        <div class="row form-group">
                                            <label class="col">Description :</label>
                                            <span class="col">{{jedescription}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <!-- <div class="row form-group">
                                            <label class="col">Reference :</label>
                                            <span class="col">{{reference}}</span>
                                        </div> -->
                                        <!-- <div class="row form-group">
                                            <label class="col">Status :</label>
                                            <span class="col">{{status}}</span>
                                        </div> -->
                                        <!-- <div class="row form-group" v-if="vehicle != ''">
                                            <label class="col">Asset :</label>
                                            <span class="col">{{vehicle}}</span>
                                        </div> -->
                                       
                                        <div class="row form-group" v-if="flag_recurring == 0">
                                            <label class="col">Fiscal Period :</label>
                                            <span class="col">{{fiscal_period}}</span>
                                        </div>
                                       
                                        <div class="row form-group">
                                            <label class="col">Reverse [Y/N] :</label>
                                            <span class="col">{{is_reverse}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="internal-container purchase-order-btm bill-view-table border-top-table-fl mt-4">
                            <template v-if="journalItems && journalItems.length == 0">
                                <div class="lineitem-main-section">
                                <h5>No Journal Items Added.</h5>
                                </div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1 purchase-order-item-table">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>GL Account</th>
                                                <th>Description</th>
                                                <th>Unit</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in journalItems" v-bind:key="index">
                                                <td> {{ item.account}} </td>
                                                <td> {{ item.description}} </td>
                                                <td> {{ item.vehicle}} </td>
                                                <td class="text-right"> {{ item.debit }} </td>
                                                <td class="text-right"> {{ item.credit }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="order-summary mt-4"> <!--Description section-->
                                    <div class="row">
                                        <div class="col-md-4 offset-md-8">
                                            <div class="bg-white radius-5 p-3">
                                                <table aria-describedby="table" class="table table-sm table-bordered">
                                                    <tr class="table-secondary">
                                                        <th></th>
                                                        <th class="text-right"> Debit </th>
                                                        <th class="text-right"> Credit </th>
                                                    </tr>
                                                    <tr>
                                                        <td> Total: </td>
                                                        <td class="order-total text-right"> ${{debitTotal}} </td>
                                                        <td class="order-total text-right"> ${{creditTotal}} </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
export default {
    name: "JournalView",
    
    mixins:[commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        journal_number:'',
        journalItems:[],
        journal_id:0,
        module_text:'-',
        reference:'-',
        post_date:'',
        status:'',
        jedescription:'',
        debitSubTotal:0,
        creditSubTotal:0,
        debitTotal:0,
        creditTotal:0,
        vehicle:'',
        canUpdateJournal:false,
        is_editable:1,
        for: "",
        flag_recurring: 0,
        fiscal_period:"",
        is_reverse:"",
        canDeleteJournal:false
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_journal') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'add_journal') {
                        self.canUpdateJournal = true;
                    }
                    if (permissions[i].name == 'delete_journal') {
                        self.canDeleteJournal = true;
                    }
                }
            }

        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.journal_id = segments[3];

        if (self.$route.query.for == 'recurring') {
          self.for = "recurring";
          self.flag_recurring = 1;
        }

        // if (self.$route.query.for == 'recurring') {
        //   self.for = "recurring";
        // }
        self.getPermissions();
        self.loadJournal();
    },
    metaInfo() {
        return {
            title: (this.journal_number != "") ? this.journal_number + " | Journal View | " +process.env.COPYRIGHT_NAME:"Journal View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        BackJournalList() {
            var self = this;

            if(self.$route.query.from != undefined && self.$route.query.from == "gl" ){
              self.$router.push('/report/general-ledger');
              return;
            }else{
              var url = '/journal/list';
              if(self.for != "" && self.for != null) {
                url = '/journal-recurring/list';
              } else {
                url = '/journal/list';
              }
              self.redirectPageUrl(url);
            }
        },
        updateJournal() {
            var self = this;

            if(self.for != "" && self.for != null) {
              self.$router.push("/journal/edit/"+self.journal_id + "?for=recurring");
            } else {
              self.$router.push("/journal/edit/"+self.journal_id);
            }


        },
        loadJournal() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;

            var CallUrl = "/journal/" + segments[3];
            if(self.for != "" && self.for != null) {
              CallUrl = "/journal-recurring/" + segments[3];
            } else {
              CallUrl = "/journal/" + segments[3];
            }
            $.ajax({
                url: process.env.ROOT_API + CallUrl,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.journal_number = data.content.journal_number;
                        if (data.content.module_value != null) {
                            self.module_text = data.content.module_text;
                            self.reference = data.content.reference_text;
                        }
                        self.post_date = data.content.post_date;
                        self.status = data.content.status_text;
                        if (data.content.description != null && data.content.description != "") {
                            self.jedescription = data.content.description;
                        }else{
                            self.jedescription = "-";
                        }
                        if (data.content.is_reverse != undefined && data.content.is_reverse != null) {
                            self.is_reverse = data.content.is_reverse;
                        }else{
                            self.is_reverse = "";
                        }
                        self.fiscal_period = data.content.fiscal_month + '/' + data.content.fiscal_year;
                        // if (data.content.fiscal_period != undefined && data.content.fiscal_period != null) {
                        //     self.fiscal_period = data.content.fiscal_period;
                        // }else{
                        //     self.fiscal_period = "";
                        // }

                        var journalItems = data.content.journalItems;
                        self.journalItems = [];

                        for (var i = 0;i<journalItems.length;i++) {

                            self.journalItems.push({
                                journal_item_id:journalItems[i].journal_item_id,
                                account:journalItems[i].account_code_description,
                                debit:(journalItems[i].debit != '')?journalItems[i].debit:'-',
                                credit:(journalItems[i].credit != '')?journalItems[i].credit:'-',
                                description:journalItems[i].description ,
                                vehicle:(journalItems[i].vehicle_id != null)?journalItems[i].vehicle:'-',
                            });
                        }
                        self.debitSubTotal = data.content.debitAmount;
                        self.debitTotal = data.content.debitAmount;
                        self.creditSubTotal = data.content.creditAmount;
                        self.creditTotal = data.content.creditAmount;
                        if (data.content.vehicle != undefined) {
                            if (data.content.vehicle != "" && data.content.vehicle != null) {
                                self.vehicle = data.content.vehicle
                            }
                        }
                        if (data.content.is_editable != undefined && data.content.is_editable != null) {
                            self.is_editable = data.content.is_editable;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'journal-view')
                }
            });
        },
        deleteJournal() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3] != undefined && segments[3] != null) {
                var flag = "";
                var promptMsg = "Are you sure that you want to delete this Journal Entry?";
                if (self.for == 'recurring') {
                    flag = "recurring";
                    promptMsg = "Are you sure that you want to delete this Journal Recurring Entry?";
                }
                self.$swal({
                    title: promptMsg,
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var idArr = [];
                        idArr.push(segments[3]);
                        self.loading = true;
                        $.ajax({
                            url:
                            process.env.ROOT_API +"/journal/delete",
                            type: "POST",
                            dataType: "json",
                            data:{id:idArr,flag:flag},
                            headers: this.ajxHeaders,

                            success: function(data) {
                                self.loading = false;
                                if (data.status == "success") {
                                    if (data.content > 0) {
                                        var url = '/journal/list';
                                        var msg = 'Journal Entry Deleted Successfully.';
                                        if(self.for != "" && self.for != null) {
                                            url = '/journal-recurring/list';
                                            msg = 'Journal Recurring Entry Deleted Successfully.';
                                        }
                                        self.$swal('',msg,'success');
                                        self.redirectPageUrl(url);
                                    }else{
                                        self.$swal('',data.content,'info');
                                    }
                                }else{
                                    self.$swal('',data.content,'info');
                                }

                            },
                            error: function(jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR,true,'delete-journal-entry')
                            }
                        });
                    } else {
                    }
                });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/JournalView.vue